import { message } from "antd";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// @ts-ignore: Allow importing CSS without type declarations
import "./App.css";
import AppLayout from "./views/layout/layout";
import Login from "./views/pages/auth/Login";
import { Suspense, useEffect } from "react";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import SiteLoader from "./views/components/SiteLoader";
import { useUserStore } from "./store/slices/user";
import { useCompanyStore } from "./store/slices/company";

function App() {
  const [messageApi, contextHolder] = message.useMessage();

  const { isLoggedIn, validateToken, isHydrated, user } = useUserStore();

  useEffect(() => {
    validateToken();
  }, []);

  const hydrateCompany = useCompanyStore((s) => s.setCompany);

  // const { data, isSuccess } = useGetMyCompany({
  //   enabled: isLoggedIn,
  // });

  // useEffect(() => {
  //   if (isSuccess && data?.data) {
  //     hydrateCompany(data.data);
  //   }
  // }, [isSuccess, data]);

  if (!isHydrated) {
    return <SiteLoader />;
  }

  return (
    <NuqsAdapter>
      <BrowserRouter basename="/">
        {contextHolder}
        <Routes>
          <Route
            path="*"
            element={
              isLoggedIn ? (
                <Suspense fallback={<SiteLoader />}>
                  <AppLayout />
                </Suspense>
              ) : (
                <Login />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </NuqsAdapter>
  );
}

export default App;
